// FTAGenAIBar.tsx — Gen AI prompt input and button (CC ≤ 5)
import React from 'react';
import { Sparkles } from 'lucide-react';
import clsx from 'clsx';

interface Props {
    prompt: string;
    setPrompt: (v: string) => void;
    onGenerate: () => void;
    isGenerating: boolean;
    isDark: boolean;
}

const FTAGenAIBar: React.FC<Props> = ({ prompt, setPrompt, onGenerate, isGenerating, isDark }) => {
    const surface = isDark ? 'bg-slate-700 border-slate-600' : 'bg-white border-slate-200';
    const textCls = isDark ? 'text-white' : 'text-slate-800';
    const ready = !isGenerating && prompt.trim().length > 0;

    return (
        <div className="flex items-center gap-2 flex-1 min-w-0 max-w-xl">
            <div className={clsx('flex-1 flex items-center gap-2 px-3 py-1.5 rounded-lg border', surface)}>
                <Sparkles size={14} className="text-indigo-500 shrink-0" />
                <input
                    value={prompt}
                    onChange={e => setPrompt(e.target.value)}
                    onKeyDown={e => e.key === 'Enter' && ready && onGenerate()}
                    placeholder="Describe a failure to generate fault tree…"
                    className={clsx('flex-1 bg-transparent text-sm focus:outline-none placeholder:text-slate-400', textCls)}
                />
            </div>
            <button
                onClick={onGenerate}
                disabled={!ready}
                className={clsx(
                    'flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-semibold transition-all shrink-0',
                    ready
                        ? 'bg-gradient-to-r from-indigo-600 to-violet-600 text-white hover:from-indigo-700 hover:to-violet-700 shadow-md shadow-indigo-200'
                        : 'bg-slate-200 text-slate-400 cursor-not-allowed'
                )}
            >
                <Sparkles size={13} />
                {isGenerating ? 'Generating…' : 'Gen AI'}
            </button>
        </div>
    );
};

export default FTAGenAIBar;
